import { Theme } from "../theme";

export const suraTheme: Theme = {
    name: 'sura',
    properties: {
      '--primary': '#0033a0',
      '--primary2': '#0033a0',
      '--primary3': '#0033a0',
      '--on-primary': '#fff',
      '--accent': '#00aec7',
      '--on-accent': '#fff',
      '--accent1': '#E3E829',
      '--error': '#FF4C4C',
      '--button-disabled': 'rgba(129, 137, 169, 0.27)',
      '--on-button-disabled': '#8189A9',
      '--hint-color': '#768692',
      '--dialog-text-color': '#53565A',
      '--nav-list-active': 'rgba(236, 240, 241, 0.5)',
      '--border-color-inactive': '#ECF0F1',
      '--box-shadow-color': '#ECF0F1',
      '--background-color-disabled': '#FBFBFB',
      '--font-icon': 'sura',
      '--font-primary': 'Barlow, FSJoey',
      '--font-secundary': 'Montserrat, sans-serif',
      '--grey': '#404040',
      '--grey2': '#DDDDDD',      
      '--grey3': '#F2F2F2',
      '--grey4': '#C4C4C4',
      '--grey5': '#757575',
      '--grey6': '#636363',
      '--grey7': '#BEBEBE',
      '--grey8': '#9E9E9E',
      '--grey9': '#505050',
      '--grey10': '#53565A',
      '--grey11': '#768692',

      '--variant-color2': '#0033a0',

      '--grayscale': '#1E1E1E',
      '--grayscale2': '#2D2D2D',
      '--grayscale3': '#3C3C3C',
      '--grayscale4': '#505050',
      '--grayscale5': '#646464',
      '--grayscale6': '#787878',
      '--grayscale7': '#8C8C8C',
      '--grayscale8': '#A0A0A0 ',
      '--grayscale9': '#B4B4B4',
      '--grayscale10': '#C8C8C8',
      '--grayscale11': '#DCDCDC',
      '--grayscale12': '#F0F0F0 ',

      '--public-profile-avatar-border-color': '#C8C8C8',

      '--public-profile-title-color': '#0033a0',
      '--public-profile-btn-appointment-color': '#0033a0',
      '--public-profile-btn-pay-color': '#505050',
      '--favicon-big': '../../assets/images/sura/pwa/Sura-512x512.png',
    }
};